import { defineStore } from 'pinia';
import { ref } from 'vue';
import axios from 'axios';

export const useAgentsStore = defineStore('agents', () => {
    const allAgents = ref([]);
    const meta = ref(null);

    const reset = () => {
        allAgents.value = [];
        meta.value = null;
    };

    const actions = {
        searchAgents: (params) => axios.post('/api/v1/agent/search', params),
        impersonate: (hash) => axios.post(`/api/v1/agent/${hash}/impersonate`),
    };

    return {
        allAgents,
        reset,
        meta,
        ...actions,
    };
});
